import React, { useRef, useState } from 'react';
import { IconButton, Slider, Box } from '@mui/material';
import {
  MdForward10,
  MdGetApp,
  MdOutlinePlayCircleFilled,
  MdOutlineReplay10,
  MdOutlineVolumeUp,
  MdPauseCircle
} from 'react-icons/md';

interface MusicPlayerProps {
  url: string;
}

const MusicPlayer: React.FC<MusicPlayerProps> = ({ url }) => {
  const audioRef = useRef<HTMLAudioElement | null>(null);
  const [isPlaying, setIsPlaying] = useState<boolean>(false);
  const [currentTime, setCurrentTime] = useState<number>(0);
  const [duration, setDuration] = useState<number>(0);

  const handlePlayPause = () => {
    if (audioRef.current) {
      if (isPlaying) {
        audioRef.current.pause();
      } else {
        audioRef.current.play();
      }
      setIsPlaying(!isPlaying);
    }
  };

  const handleTimeUpdate = () => {
    if (audioRef.current) {
      setCurrentTime(audioRef.current.currentTime);
    }
  };

  const handleLoadedMetadata = () => {
    if (audioRef.current) {
      setDuration(audioRef.current.duration);
    }
  };

  const handleSeek = (event: Event, newValue: number | number[]) => {
    if (audioRef.current) {
      audioRef.current.currentTime = newValue as number;
      setCurrentTime(newValue as number);
    }
  };

  const handleRewind = () => {
    if (audioRef.current) {
      audioRef.current.currentTime = Math.max(0, audioRef.current.currentTime - 10);
    }
  };

  const handleForward = () => {
    if (audioRef.current) {
      audioRef.current.currentTime = Math.min(audioRef.current.duration, audioRef.current.currentTime + 10);
    }
  };

  return (
    <Box display='flex' p={1} flexDirection='column' alignItems='center'>
      <audio ref={audioRef} src={url} onTimeUpdate={handleTimeUpdate} onLoadedMetadata={handleLoadedMetadata} />

      <Box display='flex' justifyContent='space-between' alignItems='center' width='100%'>
        <Slider value={currentTime} max={duration} onChange={handleSeek} sx={{ width: '100%' }} />
        <Box display='flex'>
          <IconButton>
            <MdOutlineVolumeUp />
          </IconButton>
          <IconButton href={url} download>
            <MdGetApp />
          </IconButton>
        </Box>
      </Box>

      <Box display='flex' justifyContent='space-around' width='100%'>
        <IconButton onClick={handleRewind}>
          <MdOutlineReplay10 />
        </IconButton>
        <IconButton onClick={handlePlayPause}>
          {isPlaying ? <MdPauseCircle /> : <MdOutlinePlayCircleFilled />}
        </IconButton>
        <IconButton onClick={handleForward}>
          <MdForward10 />
        </IconButton>
      </Box>
    </Box>
  );
};

export default MusicPlayer;
